// src/components/loginModal.js
import React, { useState } from 'react';
import Modal from 'react-modal';
import axios from '../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';
import '../assets/css/modal.css';

const LoginModal = ({ isOpen, onRequestClose, onLogin }) => {
    const [form, setForm] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await axios.post('/login', form);
            localStorage.setItem('token', response.data.token);
            onRequestClose(); // Close modal
            onLogin(); // Trigger login state
            navigate('/admin'); // Redirect to admin panel
        } catch (err) {
            setError('Invalid username or password. Please try again.');
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Admin Login Modal"
            className="modal-content"
            overlayClassName="modal-overlay"
        >
            <div className="modal-header">
                <h2>Admin Login</h2>
                <button onClick={onRequestClose} className="close-button">
                    &times;
                </button>
            </div>
            {error && <div className="error-message">{error}</div>}
            <form className="login-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        placeholder="Enter your username"
                        value={form.username}
                        onChange={(e) => setForm({ ...form, username: e.target.value })}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Enter your password"
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        required
                    />
                </div>
                <button type="submit" className="login-button">
                    Login
                </button>
            </form>
        </Modal>
    );
};

export default LoginModal;